import { eHierarchyLevel } from "./api/enums";
import { HierarchyReadDto } from "./api/hierarchy/HierarchyReadDto";

/**
 * Returns the level for children of the current hierarchy
 *
 * @param hierarchy - The hierarchy read DTO
 * @returns eHierarchyLevel
 */
export const childHierarchyLevel = (hierarchy: HierarchyReadDto): eHierarchyLevel | null => {
  switch (hierarchy.level) {
    case eHierarchyLevel.TopLevel:
      return eHierarchyLevel.Corporate;
    case eHierarchyLevel.Corporate:
      return eHierarchyLevel.TA;
    case eHierarchyLevel.TA:
      return eHierarchyLevel.Project;
    case eHierarchyLevel.Project:
      return eHierarchyLevel.Study;
    case eHierarchyLevel.Study:
      return eHierarchyLevel.Report;
    case eHierarchyLevel.Report:
      return null;
  }
};
